<section class="cart">
    <div class="container">
        <table class="table">
            <tr>
                <th>Article Name</th>
                <th>Category</th>
                <th>size</th>
                <th>No. of Days</th>
                <th>Rent</th>
                <th></th>
            </tr>
            <tr style="border-bottom:1px solid black">
                <td colspan="90%"><hr style="width:98%;"></td>
              </tr>
            <tr *ngFor="let cloth of clothes;index as i">
                <td>{{cloth.dress_name}}</td>
                <td *ngIf="cloth.category == 1">Bridal</td>
                <td *ngIf="cloth.category == 2">Casual</td>
                <td *ngIf="cloth.category == 3">New</td>
                <td *ngIf="cloth.category == 4">Suits</td>
                <td *ngIf="cloth.category == 5">Groom</td>
                <td>{{cloth.size}}</td>
                <td>{{cloth.orderedDays}}</td>
                <td>{{cloth.basic_rent}}</td>
                <td><i class="fas fa-times" (click)="deleteDress(i)"></i></td>
            </tr>
        </table>
        <button class="button" (click)="proceedToCheckout()">Proceed to Checkout</button>
    </div>
</section>